import { ITranslationKeys } from '@interfaces';
import { INormalizedShipItemList, INShipitem } from '@interfaces/ship';
import React from 'react';
import { numberFormat } from '../../../../utils/formatting';
import { __ } from '../../../../utils/translation-service';
import { StyledShipColumnWrapper, StyledTable } from './ship-column.style';
import { shipDetailItemsLabels } from '../ship-detail-label';

interface IShipColumnProps {
    shipItems: INormalizedShipItemList;
    headline: string;
}
export const ShipColumn = ({ shipItems, headline }: IShipColumnProps) => {
    const shipList =
        shipItems &&
        (Object.keys(shipItems) as (keyof typeof shipItems)[]).map((key) => {
            const value = shipItems[key].value;

            if (!value) {
                return;
            }

            return (
                <tr key={key}>
                    <th>{__(shipItems[key].label as any as ITranslationKeys)}</th>
                    <td>{formattedAmount(shipItems[key])}</td>
                </tr>
            );
        });

    return (
        <StyledShipColumnWrapper>
            <StyledTable aria-label="ship data">
                <colgroup>
                    <col />
                    <col />
                </colgroup>
                <thead>
                    <tr>
                        <th>{headline}</th>
                        <th />
                    </tr>
                </thead>
                <tbody>{shipList}</tbody>
            </StyledTable>
        </StyledShipColumnWrapper>
    );
};

const formattedAmount = (item: INShipitem) =>
    typeof item.value === 'number' &&
    item.label !== shipDetailItemsLabels.launchDate.label &&
    item.label !== shipDetailItemsLabels.refurbishmentYear.label
        ? numberFormat(item.value)
        : item.value;
